import { render, staticRenderFns } from "./HistoryDianotic.vue?vue&type=template&id=20644f64&scoped=true&"
import script from "./HistoryDianotic.vue?vue&type=script&lang=js&"
export * from "./HistoryDianotic.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDianotic.vue?vue&type=style&index=0&id=20644f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20644f64",
  null
  
)

export default component.exports